import React, { useId, useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import Loader from "../shared/Loader/Loader";

const FileTag = ({
  name,
  defaultValue,
  multiple,
  label,
  length,
  required,
  handleSingleDelete,
  isGalleryFile,
}) => {
  const [value, setValue] = useState(defaultValue?.url);
  const [preview, setPreview] = useState(defaultValue?.url);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(true);
  const [preProcess, setPreProcess] = useState(false);
  const inputId = `imageUpload-${useId().replace(/:/g, "")}`;


  // const handleFileChange = async (event) => {
  //   const image = event.target.files[0];
  //   const formData = new FormData();
  //   formData.append("image", image);
  //   const url = `https://api.imgbb.com/1/upload?key=${imageStoraeKey}`;
  //   setLoading(true);
  //   await fetch(url, {
  //     method: "POST",
  //     body: formData,
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       if (result.success) {
  //         console.log(result.data.url, 'after success imgbb');
  //         setValue(result.data.url);
  //         setLoading(false);
  //       }
  //     });

  //   setPreview(URL.createObjectURL(event.target.files[0]));
  // };

  const handleFileChange = async (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image);

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}api/v1/image-upload?process=${preProcess}`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (response.ok && result.filename) {
        const imageUrl = result.filename;
        console.log(imageUrl);
        setValue(imageUrl);
        setPreview(imageUrl);
      } else {
        console.error("Upload failed:", result.error || "Unknown error");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }

    setLoading(false);
  };



  const handleDelete = async () => {
    if (isGalleryFile) {
      setVisibility(false);
    } else {
      const res = await handleSingleDelete(defaultValue._id);
      if (typeof res === "boolean" && res === true) {
        setVisibility(false);
      }
    }
  };

  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-center w-full" : "hidden"}
    >
      <div className="w-full relative pt-8">
        <label
          className="flex justify-center w-full h-32 transition bg-white border border-gray-300 rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
          style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9)),url('${`${process.env.REACT_APP_API_URL}images/${preview}`}')`,
            backgroundSize: "cover",
          }}
          htmlFor={inputId}
        >
          <span className="absolute top-0 left-0 font-semibold cursor-default capitalize">
            {length ? label + " " + length : label}
            {required && <span className="text-red-500 text-lg">*</span>}
          </span>
          <div
            className="absolute top-0 right-0 flex items-center text-sm"
            onClick={(e) => e.stopPropagation()}
          >
            Process
            <input
              type="checkbox"
              checked={preProcess}
              onChange={(e) => setPreProcess(e.target.checked)}
              className="ml-2 w-4 h-4 accent-white cursor-pointer"
            />
          </div>

          <span className="flex flex-col justify-center items-center space-x-2 text-white">
            {loading ? (
              <Loader />
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
                <span className="font-medium text-center">
                  {visibility ? (length ? label + " " + length : label) : ""}
                </span>
              </>
            )}
          </span>
          <input
            id={inputId}
            onChange={handleFileChange}
            type="file"
            name={visibility ? name : ""}
            className="hidden"
            src={`${process.env.REACT_APP_API_URL}images/${value}`}
            alt={defaultValue?._id ? defaultValue?._id : ""}
            accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
          />
        </label>
      </div>
      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle border border-gray-400 rounded-full mt-8 p-2 hover:bg-gray-50"
          title="Remove"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default FileTag;
